import { Anchor } from "@mantine/core";
import { getYearString } from "../../../helpers/stringHelper";
import type { Document } from "../../../models/document";
import { occupationTranslations } from "../../../models/enums/occupation";
import { DataTable, type DataTableProps } from "../../datatable/DataTable";
import { StatusIndicator } from "../../indicator/StatusIndicator";

type GlobalDocumentTableProps = Required<
  Pick<
    DataTableProps<Document>,
    "onEdit" | "onDelete" | "onView" | "onSortStatusChange" | "sortStatus" | "pagination" | "onPageChange" | "fetching"
  >
> & {
  documents: Document[];
};

export function GlobalDocumentTable({ documents, onView, ...props }: GlobalDocumentTableProps) {
  return (
    <DataTable
      columns={[
        {
          accessor: "title",
          title: "Titel",
          sortable: true,
          render: (document) => <Anchor onClick={() => onView(document)}>{document.title}</Anchor>,
        },
        {
          accessor: "year_context",
          title: "Jahrgang",
          sortable: true,
          render: (document) => getYearString(document.year_context),
        },
        {
          accessor: "occupation",
          title: "Beruf",
          sortable: true,
          render: (document) => (document.occupation ? occupationTranslations[document.occupation] : "-"),
        },
        {
          accessor: "group.name",
          title: "Gruppe",
          sortable: true,
          render: (document) => (document.group ? document.group.name : "-"),
        },
        {
          accessor: "publish",
          title: "Freigegeben",
          width: "0%",
          render: (document) => <StatusIndicator active={document.publish} />,
        },
      ]}
      records={documents}
      onView={onView}
      {...props}
    />
  );
}
